import { colors } from '../../../../../colors';
import ColoredCheckbox from '../../../../../components/ColoredCheckbox';
import './index.css';

interface Props {
  isCompareToProfitCalcs: boolean;
  setIsCompareToProfitCalcs: React.Dispatch<React.SetStateAction<boolean>>;
}

const isCompareToProfitCalcsColor = colors.red;

const ChartOptions: React.FC<Props> = (props: Props) => {
  const { isCompareToProfitCalcs, setIsCompareToProfitCalcs } = props;

  return (
    <div className="profit-chart-options-root">
      <div className="profit-chart-options-column">
        <div className="profit-chart-options-item">
          <ColoredCheckbox
            value={isCompareToProfitCalcs}
            handleValueChange={setIsCompareToProfitCalcs}
            color={isCompareToProfitCalcsColor}
            size={10}
          />
          <span
            className="profit-chart-options-label"
            style={{
              color: isCompareToProfitCalcs
                ? isCompareToProfitCalcsColor
                : colors.white,
            }}
          >
            Compare to Profit Calcs
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChartOptions;
